export const SET_PLAYGROUND_REPETITIONS_TOOL_NAME =
  "set_playground_repetitions";
